//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { optionsTransformer } from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import moment from 'moment';

export class BaseClient {
    getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
        if (parsedBaseUrl) {
            return parsedBaseUrl;
        }

        if (!process.env.NLL_SERVICE_URL) {
            throw new Error('NLL_SERVICE_URL must be set in environment');
        }

        return process.env.NLL_SERVICE_URL;
    }

    async transformOptions(options: RequestInit): Promise<RequestInit> {
        return optionsTransformer.addDefaultHeaders(options);
    }
}

export class MetadataClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    index(signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/sambi/metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ServiceWindowClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getScheduledAndActive(signal?: AbortSignal, headers?: HeadersInit): Promise<ServiceWindowResponse[]> {
        let url_ = this.baseUrl + "/api/ServiceWindow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScheduledAndActive(_response);
        });
    }

    protected processGetScheduledAndActive(response: Response): Promise<ServiceWindowResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceWindowResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceWindowResponse[]>(null as any);
    }
}

export class SambiLoginClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    initiateSambiLogin(returnUrl: string | undefined, errorReturnUrl: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<InitiateSambiLoginResponse> {
        let url_ = this.baseUrl + "/api/SambiLogin/initiate?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (errorReturnUrl === null)
            throw new Error("The parameter 'errorReturnUrl' cannot be null.");
        else if (errorReturnUrl !== undefined)
            url_ += "errorReturnUrl=" + encodeURIComponent("" + errorReturnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateSambiLogin(_response);
        });
    }

    protected processInitiateSambiLogin(response: Response): Promise<InitiateSambiLoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiateSambiLoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiateSambiLoginResponse>(null as any);
    }

    sambiCallback(signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SambiLogin/callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSambiCallback(_response);
        });
    }

    protected processSambiCallback(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PrescriptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getPrescriptionsForResident(residentId: string, patientSessionId: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<ResidentPrescriptionsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptions?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (patientSessionId === null)
            throw new Error("The parameter 'patientSessionId' cannot be null.");
        else if (patientSessionId !== undefined)
            url_ += "patientSessionId=" + encodeURIComponent("" + patientSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionsForResident(_response);
        });
    }

    protected processGetPrescriptionsForResident(response: Response): Promise<ResidentPrescriptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentPrescriptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentPrescriptionsResponse>(null as any);
    }

    getPrescriptionVersionForResident(residentId: string, prescriptionId: string, version: number, patientSessionId: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionVersionResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptions/{prescriptionId}/history/{version}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (patientSessionId === null)
            throw new Error("The parameter 'patientSessionId' cannot be null.");
        else if (patientSessionId !== undefined)
            url_ += "patientSessionId=" + encodeURIComponent("" + patientSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionVersionForResident(_response);
        });
    }

    protected processGetPrescriptionVersionForResident(response: Response): Promise<PrescriptionVersionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionVersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionVersionResponse>(null as any);
    }

    getPrescriptionEvents(residentId: string, prescriptionId: string, patientSessionId: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionEventsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptions/{prescriptionId}/events?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (patientSessionId === null)
            throw new Error("The parameter 'patientSessionId' cannot be null.");
        else if (patientSessionId !== undefined)
            url_ += "patientSessionId=" + encodeURIComponent("" + patientSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionEvents(_response);
        });
    }

    protected processGetPrescriptionEvents(response: Response): Promise<PrescriptionEventsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionEventsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionEventsResponse>(null as any);
    }
}

export class PatientClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    initiateSession(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PatientSessionInitiatedResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/patient/initiateSession";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateSession(_response);
        });
    }

    protected processInitiateSession(response: Response): Promise<PatientSessionInitiatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientSessionInitiatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientSessionInitiatedResponse>(null as any);
    }
}

export class NllValueSetClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getNllDoseUnits(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ValueSetDisplay[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/nll-value-sets/dose-units";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNllDoseUnits(_response);
        });
    }

    protected processGetNllDoseUnits(response: Response): Promise<ValueSetDisplay[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValueSetDisplay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueSetDisplay[]>(null as any);
    }
}

export class NllConnectivityTestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    pingAsM2M(signal?: AbortSignal, headers?: HeadersInit): Promise<string> {
        let url_ = this.baseUrl + "/api/nllConnectivity/pingm2m";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPingAsM2M(_response);
        });
    }

    protected processPingAsM2M(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pingAsUser(signal?: AbortSignal, headers?: HeadersInit): Promise<string> {
        let url_ = this.baseUrl + "/api/nllConnectivity/pingasuser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPingAsUser(_response);
        });
    }

    protected processPingAsUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MedicationListInfoClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getMedicationListInfo(residentId: string, patientSessionId: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<MedicationListInfoResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/medicationListInfo?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (patientSessionId === null)
            throw new Error("The parameter 'patientSessionId' cannot be null.");
        else if (patientSessionId !== undefined)
            url_ += "patientSessionId=" + encodeURIComponent("" + patientSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMedicationListInfo(_response);
        });
    }

    protected processGetMedicationListInfo(response: Response): Promise<MedicationListInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationListInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationListInfoResponse>(null as any);
    }
}

export class HealthcareProviderInformationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getHealthcareProviderInformation(customerId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<HealthcareProviderInformationResponse> {
        let url_ = this.baseUrl + "/api/HealthcareProviderInformation/customers/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHealthcareProviderInformation(_response);
        });
    }

    protected processGetHealthcareProviderInformation(response: Response): Promise<HealthcareProviderInformationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthcareProviderInformationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthcareProviderInformationResponse>(null as any);
    }

    upsertHealthcareProviderInformation(request: HealthcareProviderInformationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/HealthcareProviderInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertHealthcareProviderInformation(_response);
        });
    }

    protected processUpsertHealthcareProviderInformation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DataLockClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    getDataLockDetails(residentId: string, dataLockId: string, patientSessionId: string | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<DataLockDetailsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/DataLock/{dataLockId}/details?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (dataLockId === undefined || dataLockId === null)
            throw new Error("The parameter 'dataLockId' must be defined.");
        url_ = url_.replace("{dataLockId}", encodeURIComponent("" + dataLockId));
        if (patientSessionId === null)
            throw new Error("The parameter 'patientSessionId' cannot be null.");
        else if (patientSessionId !== undefined)
            url_ += "patientSessionId=" + encodeURIComponent("" + patientSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataLockDetails(_response);
        });
    }

    protected processGetDataLockDetails(response: Response): Promise<DataLockDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataLockDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataLockDetailsResponse>(null as any);
    }
}

export class ConsentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-dev.sekoia.one", baseUrl);
    }

    establishPreObtainedConsents(residentId: string, request: EstablishPreObtainedConsentsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<PreObtainedConsentsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/Consent/preObtained";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstablishPreObtainedConsents(_response);
        });
    }

    protected processEstablishPreObtainedConsents(response: Response): Promise<PreObtainedConsentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            let resultData424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result424 = NllErrorInformationResponse.fromJS(resultData424);
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreObtainedConsentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreObtainedConsentsResponse>(null as any);
    }

    selectConsent(request: SelectConsentRequest, residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/Consent/selectConsent";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSelectConsent(_response);
        });
    }

    protected processSelectConsent(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    elevate(residentId: string, request: ElevateConsentRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/Consent/elevate";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElevate(_response);
        });
    }

    protected processElevate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ServiceWindowResponse implements IServiceWindowResponse {
    start!: moment.Moment;
    end!: moment.Moment;
    displayText?: string | null;
    advanceNoticeFrom?: moment.Moment | null;
    advanceNoticeDisplayText?: string | null;

    constructor(data?: IServiceWindowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
            this.advanceNoticeFrom = _data["advanceNoticeFrom"] ? moment(_data["advanceNoticeFrom"].toString()) : <any>null;
            this.advanceNoticeDisplayText = _data["advanceNoticeDisplayText"] !== undefined ? _data["advanceNoticeDisplayText"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceWindowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWindowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>null;
        data["end"] = this.end ? this.end.toISOString() : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        data["advanceNoticeFrom"] = this.advanceNoticeFrom ? this.advanceNoticeFrom.toISOString() : <any>null;
        data["advanceNoticeDisplayText"] = this.advanceNoticeDisplayText !== undefined ? this.advanceNoticeDisplayText : <any>null;
        return data;
    }
}

export interface IServiceWindowResponse {
    start: moment.Moment;
    end: moment.Moment;
    displayText?: string | null;
    advanceNoticeFrom?: moment.Moment | null;
    advanceNoticeDisplayText?: string | null;
}

export class InitiateSambiLoginResponse implements IInitiateSambiLoginResponse {
    redirectLocation?: string | null;
    hasExistingValidSession!: boolean;

    constructor(data?: IInitiateSambiLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectLocation = _data["redirectLocation"] !== undefined ? _data["redirectLocation"] : <any>null;
            this.hasExistingValidSession = _data["hasExistingValidSession"] !== undefined ? _data["hasExistingValidSession"] : <any>null;
        }
    }

    static fromJS(data: any): InitiateSambiLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateSambiLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectLocation"] = this.redirectLocation !== undefined ? this.redirectLocation : <any>null;
        data["hasExistingValidSession"] = this.hasExistingValidSession !== undefined ? this.hasExistingValidSession : <any>null;
        return data;
    }
}

export interface IInitiateSambiLoginResponse {
    redirectLocation?: string | null;
    hasExistingValidSession: boolean;
}

export class NllErrorInformationResponse implements INllErrorInformationResponse {
    errors!: NllErrorResponse[];
    httpStatusCode!: number;

    constructor(data?: INllErrorInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(NllErrorResponse.fromJS(item));
            }
            else {
                this.errors = <any>null;
            }
            this.httpStatusCode = _data["httpStatusCode"] !== undefined ? _data["httpStatusCode"] : <any>null;
        }
    }

    static fromJS(data: any): NllErrorInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NllErrorInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : <any>null);
        }
        data["httpStatusCode"] = this.httpStatusCode !== undefined ? this.httpStatusCode : <any>null;
        return data;
    }
}

export interface INllErrorInformationResponse {
    errors: NllErrorResponse[];
    httpStatusCode: number;
}

export class NllErrorResponse implements INllErrorResponse {
    message!: string;

    constructor(data?: INllErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): NllErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NllErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface INllErrorResponse {
    message: string;
}

export class ResidentPrescriptionsResponse implements IResidentPrescriptionsResponse {
    paperPrescriptionsDataLocks!: DataLockResponse[];
    prescriptionGroups!: PrescriptionGroupsResponse;

    constructor(data?: IResidentPrescriptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paperPrescriptionsDataLocks = [];
            this.prescriptionGroups = new PrescriptionGroupsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paperPrescriptionsDataLocks"])) {
                this.paperPrescriptionsDataLocks = [] as any;
                for (let item of _data["paperPrescriptionsDataLocks"])
                    this.paperPrescriptionsDataLocks!.push(DataLockResponse.fromJS(item));
            }
            else {
                this.paperPrescriptionsDataLocks = <any>null;
            }
            this.prescriptionGroups = _data["prescriptionGroups"] ? PrescriptionGroupsResponse.fromJS(_data["prescriptionGroups"]) : new PrescriptionGroupsResponse();
        }
    }

    static fromJS(data: any): ResidentPrescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentPrescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paperPrescriptionsDataLocks)) {
            data["paperPrescriptionsDataLocks"] = [];
            for (let item of this.paperPrescriptionsDataLocks)
                data["paperPrescriptionsDataLocks"].push(item ? item.toJSON() : <any>null);
        }
        data["prescriptionGroups"] = this.prescriptionGroups ? this.prescriptionGroups.toJSON() : <any>null;
        return data;
    }
}

export interface IResidentPrescriptionsResponse {
    paperPrescriptionsDataLocks: DataLockResponse[];
    prescriptionGroups: PrescriptionGroupsResponse;
}

export class DataLockResponse implements IDataLockResponse {
    id!: string;
    dataLockType!: DataLockType;
    dataLockTypeDisplayText!: string;
    dataLockSubject!: string;

    constructor(data?: IDataLockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dataLockType = _data["dataLockType"] !== undefined ? _data["dataLockType"] : <any>null;
            this.dataLockTypeDisplayText = _data["dataLockTypeDisplayText"] !== undefined ? _data["dataLockTypeDisplayText"] : <any>null;
            this.dataLockSubject = _data["dataLockSubject"] !== undefined ? _data["dataLockSubject"] : <any>null;
        }
    }

    static fromJS(data: any): DataLockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataLockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dataLockType"] = this.dataLockType !== undefined ? this.dataLockType : <any>null;
        data["dataLockTypeDisplayText"] = this.dataLockTypeDisplayText !== undefined ? this.dataLockTypeDisplayText : <any>null;
        data["dataLockSubject"] = this.dataLockSubject !== undefined ? this.dataLockSubject : <any>null;
        return data;
    }
}

export interface IDataLockResponse {
    id: string;
    dataLockType: DataLockType;
    dataLockTypeDisplayText: string;
    dataLockSubject: string;
}

export enum DataLockType {
    Privacy = "Privacy",
    ConfidentialityPatient = "ConfidentialityPatient",
    ConfidentialityGuardian = "ConfidentialityGuardian",
}

export class PrescriptionGroupsResponse implements IPrescriptionGroupsResponse {
    pharmaceuticalPrescriptions!: PrescriptionResponse[];
    medicalConsumablePrescriptions!: PrescriptionResponse[];
    paperPrescriptions!: PaperPrescriptionResponse[];

    constructor(data?: IPrescriptionGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pharmaceuticalPrescriptions = [];
            this.medicalConsumablePrescriptions = [];
            this.paperPrescriptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pharmaceuticalPrescriptions"])) {
                this.pharmaceuticalPrescriptions = [] as any;
                for (let item of _data["pharmaceuticalPrescriptions"])
                    this.pharmaceuticalPrescriptions!.push(PrescriptionResponse.fromJS(item));
            }
            else {
                this.pharmaceuticalPrescriptions = <any>null;
            }
            if (Array.isArray(_data["medicalConsumablePrescriptions"])) {
                this.medicalConsumablePrescriptions = [] as any;
                for (let item of _data["medicalConsumablePrescriptions"])
                    this.medicalConsumablePrescriptions!.push(PrescriptionResponse.fromJS(item));
            }
            else {
                this.medicalConsumablePrescriptions = <any>null;
            }
            if (Array.isArray(_data["paperPrescriptions"])) {
                this.paperPrescriptions = [] as any;
                for (let item of _data["paperPrescriptions"])
                    this.paperPrescriptions!.push(PaperPrescriptionResponse.fromJS(item));
            }
            else {
                this.paperPrescriptions = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pharmaceuticalPrescriptions)) {
            data["pharmaceuticalPrescriptions"] = [];
            for (let item of this.pharmaceuticalPrescriptions)
                data["pharmaceuticalPrescriptions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.medicalConsumablePrescriptions)) {
            data["medicalConsumablePrescriptions"] = [];
            for (let item of this.medicalConsumablePrescriptions)
                data["medicalConsumablePrescriptions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.paperPrescriptions)) {
            data["paperPrescriptions"] = [];
            for (let item of this.paperPrescriptions)
                data["paperPrescriptions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionGroupsResponse {
    pharmaceuticalPrescriptions: PrescriptionResponse[];
    medicalConsumablePrescriptions: PrescriptionResponse[];
    paperPrescriptions: PaperPrescriptionResponse[];
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: string;
    version!: number;
    prescriptionFormat!: string;
    prescriptionChainId!: string;
    isPartOfPrescriptionChain!: boolean;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoResponse | null;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    medication!: MedicationResponse;
    treatmentReason?: string | null;
    dosageInstructions!: DosageInstructionResponse[];
    dataLocks!: DataLockResponse[];
    practitioner!: PractitionerResponse;
    dispenseInformation!: DispenseInformationResponse;
    warnings!: WarningResponse[];
    medicationDispenses!: MedicationDispenseResponse[];
    notes!: NoteResponse[];
    prescriptionReasons!: PrescriptionReasonResponse[];

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationResponse();
            this.dosageInstructions = [];
            this.dataLocks = [];
            this.practitioner = new PractitionerResponse();
            this.dispenseInformation = new DispenseInformationResponse();
            this.warnings = [];
            this.medicationDispenses = [];
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : <any>null;
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : <any>null;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : <any>null;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoResponse.fromJS(_data["priorityInfo"]) : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : <any>null;
            this.medication = _data["medication"] ? MedicationResponse.fromJS(_data["medication"]) : new MedicationResponse();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionResponse.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            if (Array.isArray(_data["dataLocks"])) {
                this.dataLocks = [] as any;
                for (let item of _data["dataLocks"])
                    this.dataLocks!.push(DataLockResponse.fromJS(item));
            }
            else {
                this.dataLocks = <any>null;
            }
            this.practitioner = _data["practitioner"] ? PractitionerResponse.fromJS(_data["practitioner"]) : new PractitionerResponse();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationResponse.fromJS(_data["dispenseInformation"]) : new DispenseInformationResponse();
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(WarningResponse.fromJS(item));
            }
            else {
                this.warnings = <any>null;
            }
            if (Array.isArray(_data["medicationDispenses"])) {
                this.medicationDispenses = [] as any;
                for (let item of _data["medicationDispenses"])
                    this.medicationDispenses!.push(MedicationDispenseResponse.fromJS(item));
            }
            else {
                this.medicationDispenses = <any>null;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteResponse.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonResponse.fromJS(item));
            }
            else {
                this.prescriptionReasons = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : <any>null;
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : <any>null;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : <any>null;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.dataLocks)) {
            data["dataLocks"] = [];
            for (let item of this.dataLocks)
                data["dataLocks"].push(item ? item.toJSON() : <any>null);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : <any>null;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.medicationDispenses)) {
            data["medicationDispenses"] = [];
            for (let item of this.medicationDispenses)
                data["medicationDispenses"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionResponse {
    id: string;
    version: number;
    prescriptionFormat: string;
    prescriptionChainId: string;
    isPartOfPrescriptionChain: boolean;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoResponse | null;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    medication: MedicationResponse;
    treatmentReason?: string | null;
    dosageInstructions: DosageInstructionResponse[];
    dataLocks: DataLockResponse[];
    practitioner: PractitionerResponse;
    dispenseInformation: DispenseInformationResponse;
    warnings: WarningResponse[];
    medicationDispenses: MedicationDispenseResponse[];
    notes: NoteResponse[];
    prescriptionReasons: PrescriptionReasonResponse[];
}

export enum PrescriptionStatus {
    Active = "Active",
    OnHold = "OnHold",
    Cancelled = "Cancelled",
    Completed = "Completed",
    Stopped = "Stopped",
}

export class PrescriptionPriorityInfoResponse implements IPrescriptionPriorityInfoResponse {
    priority!: PrescriptionPriority;
    displayText!: string;

    constructor(data?: IPrescriptionPriorityInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionPriorityInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionPriorityInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IPrescriptionPriorityInfoResponse {
    priority: PrescriptionPriority;
    displayText: string;
}

export enum PrescriptionPriority {
    Urgent = "urgent",
}

export class MedicationResponse implements IMedicationResponse {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    interchangeSubstanceGroup?: string | null;
    form?: string | null;
    strength?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationResponse | null;

    constructor(data?: IMedicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplPackId = _data["nplPackId"] !== undefined ? _data["nplPackId"] : <any>null;
            this.medicalConsumableId = _data["medicalConsumableId"] !== undefined ? _data["medicalConsumableId"] : <any>null;
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : <any>null;
            this.interchangeSubstanceGroup = _data["interchangeSubstanceGroup"] !== undefined ? _data["interchangeSubstanceGroup"] : <any>null;
            this.form = _data["form"] !== undefined ? _data["form"] : <any>null;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.packageContainer = _data["packageContainer"] !== undefined ? _data["packageContainer"] : <any>null;
            this.packageDescription = _data["packageDescription"] !== undefined ? _data["packageDescription"] : <any>null;
            this.atcClearText = _data["atcClearText"] !== undefined ? _data["atcClearText"] : <any>null;
            this.atcCode = _data["atcCode"] !== undefined ? _data["atcCode"] : <any>null;
            this.articleSummaryHtml = _data["articleSummaryHtml"] !== undefined ? _data["articleSummaryHtml"] : <any>null;
            this.amountDescription = _data["amountDescription"] !== undefined ? _data["amountDescription"] : <any>null;
            this.packagingUnit = _data["packagingUnit"] !== undefined ? _data["packagingUnit"] : <any>null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : <any>null;
            this.narcoticClassification = _data["narcoticClassification"] ? NarcoticClassificationResponse.fromJS(_data["narcoticClassification"]) : <any>null;
        }
    }

    static fromJS(data: any): MedicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplPackId"] = this.nplPackId !== undefined ? this.nplPackId : <any>null;
        data["medicalConsumableId"] = this.medicalConsumableId !== undefined ? this.medicalConsumableId : <any>null;
        data["nplId"] = this.nplId !== undefined ? this.nplId : <any>null;
        data["interchangeSubstanceGroup"] = this.interchangeSubstanceGroup !== undefined ? this.interchangeSubstanceGroup : <any>null;
        data["form"] = this.form !== undefined ? this.form : <any>null;
        data["strength"] = this.strength !== undefined ? this.strength : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["packageContainer"] = this.packageContainer !== undefined ? this.packageContainer : <any>null;
        data["packageDescription"] = this.packageDescription !== undefined ? this.packageDescription : <any>null;
        data["atcClearText"] = this.atcClearText !== undefined ? this.atcClearText : <any>null;
        data["atcCode"] = this.atcCode !== undefined ? this.atcCode : <any>null;
        data["articleSummaryHtml"] = this.articleSummaryHtml !== undefined ? this.articleSummaryHtml : <any>null;
        data["amountDescription"] = this.amountDescription !== undefined ? this.amountDescription : <any>null;
        data["packagingUnit"] = this.packagingUnit !== undefined ? this.packagingUnit : <any>null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : <any>null;
        data["narcoticClassification"] = this.narcoticClassification ? this.narcoticClassification.toJSON() : <any>null;
        return data;
    }
}

export interface IMedicationResponse {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    interchangeSubstanceGroup?: string | null;
    form?: string | null;
    strength?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationResponse | null;
}

export class NarcoticClassificationResponse implements INarcoticClassificationResponse {
    code!: NarcoticClassificationCode;
    text!: string;

    constructor(data?: INarcoticClassificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): NarcoticClassificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticClassificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface INarcoticClassificationResponse {
    code: NarcoticClassificationCode;
    text: string;
}

export enum NarcoticClassificationCode {
    NotNarcotics = "NotNarcotics",
    NotApplicable = "NotApplicable",
    Classification1 = "Classification1",
    Classification2 = "Classification2",
    Classification3 = "Classification3",
    Classification4 = "Classification4",
    Classification5 = "Classification5",
}

export class DosageInstructionResponse implements IDosageInstructionResponse {
    text!: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence!: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction!: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodResponse | null;
    method?: DosageMethodResponse | null;
    site?: DosageSiteResponse | null;
    siteQualifier?: DosageSiteQualifierResponse | null;
    timing?: DosageTimingResponse | null;
    doseAndRate?: DosageDoseAndRateResponse | null;
    route?: DosageRouteResponse | null;
    medicalDevice?: DosageMedicalDeviceResponse | null;

    constructor(data?: IDosageInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.asNeeded = _data["asNeeded"] !== undefined ? _data["asNeeded"] : <any>null;
            this.administeringInstruction = _data["administeringInstruction"] !== undefined ? _data["administeringInstruction"] : <any>null;
            this.additionalInstruction = _data["additionalInstruction"] !== undefined ? _data["additionalInstruction"] : <any>null;
            this.observandumDose = _data["observandumDose"] !== undefined ? _data["observandumDose"] : <any>null;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : <any>null;
            this.subSequence = _data["subSequence"] !== undefined ? _data["subSequence"] : <any>null;
            this.dosageType = _data["dosageType"] !== undefined ? _data["dosageType"] : <any>null;
            this.patientInstruction = _data["patientInstruction"] !== undefined ? _data["patientInstruction"] : <any>null;
            this.maxDosePerPeriod = _data["maxDosePerPeriod"] ? DosageMaxDosePerPeriodResponse.fromJS(_data["maxDosePerPeriod"]) : <any>null;
            this.method = _data["method"] ? DosageMethodResponse.fromJS(_data["method"]) : <any>null;
            this.site = _data["site"] ? DosageSiteResponse.fromJS(_data["site"]) : <any>null;
            this.siteQualifier = _data["siteQualifier"] ? DosageSiteQualifierResponse.fromJS(_data["siteQualifier"]) : <any>null;
            this.timing = _data["timing"] ? DosageTimingResponse.fromJS(_data["timing"]) : <any>null;
            this.doseAndRate = _data["doseAndRate"] ? DosageDoseAndRateResponse.fromJS(_data["doseAndRate"]) : <any>null;
            this.route = _data["route"] ? DosageRouteResponse.fromJS(_data["route"]) : <any>null;
            this.medicalDevice = _data["medicalDevice"] ? DosageMedicalDeviceResponse.fromJS(_data["medicalDevice"]) : <any>null;
        }
    }

    static fromJS(data: any): DosageInstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageInstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["asNeeded"] = this.asNeeded !== undefined ? this.asNeeded : <any>null;
        data["administeringInstruction"] = this.administeringInstruction !== undefined ? this.administeringInstruction : <any>null;
        data["additionalInstruction"] = this.additionalInstruction !== undefined ? this.additionalInstruction : <any>null;
        data["observandumDose"] = this.observandumDose !== undefined ? this.observandumDose : <any>null;
        data["sequence"] = this.sequence !== undefined ? this.sequence : <any>null;
        data["subSequence"] = this.subSequence !== undefined ? this.subSequence : <any>null;
        data["dosageType"] = this.dosageType !== undefined ? this.dosageType : <any>null;
        data["patientInstruction"] = this.patientInstruction !== undefined ? this.patientInstruction : <any>null;
        data["maxDosePerPeriod"] = this.maxDosePerPeriod ? this.maxDosePerPeriod.toJSON() : <any>null;
        data["method"] = this.method ? this.method.toJSON() : <any>null;
        data["site"] = this.site ? this.site.toJSON() : <any>null;
        data["siteQualifier"] = this.siteQualifier ? this.siteQualifier.toJSON() : <any>null;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>null;
        data["doseAndRate"] = this.doseAndRate ? this.doseAndRate.toJSON() : <any>null;
        data["route"] = this.route ? this.route.toJSON() : <any>null;
        data["medicalDevice"] = this.medicalDevice ? this.medicalDevice.toJSON() : <any>null;
        return data;
    }
}

export interface IDosageInstructionResponse {
    text: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodResponse | null;
    method?: DosageMethodResponse | null;
    site?: DosageSiteResponse | null;
    siteQualifier?: DosageSiteQualifierResponse | null;
    timing?: DosageTimingResponse | null;
    doseAndRate?: DosageDoseAndRateResponse | null;
    route?: DosageRouteResponse | null;
    medicalDevice?: DosageMedicalDeviceResponse | null;
}

export class DosageMaxDosePerPeriodResponse implements IDosageMaxDosePerPeriodResponse {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;

    constructor(data?: IDosageMaxDosePerPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseValue = _data["doseValue"] !== undefined ? _data["doseValue"] : <any>null;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : <any>null;
            this.dosePeriod = _data["dosePeriod"] !== undefined ? _data["dosePeriod"] : <any>null;
            this.dosePeriodUnit = _data["dosePeriodUnit"] !== undefined ? _data["dosePeriodUnit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMaxDosePerPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMaxDosePerPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseValue"] = this.doseValue !== undefined ? this.doseValue : <any>null;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : <any>null;
        data["dosePeriod"] = this.dosePeriod !== undefined ? this.dosePeriod : <any>null;
        data["dosePeriodUnit"] = this.dosePeriodUnit !== undefined ? this.dosePeriodUnit : <any>null;
        return data;
    }
}

export interface IDosageMaxDosePerPeriodResponse {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;
}

export class DosageMethodResponse implements IDosageMethodResponse {
    method!: string;
    otherMethodDescription?: string | null;

    constructor(data?: IDosageMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.otherMethodDescription = _data["otherMethodDescription"] !== undefined ? _data["otherMethodDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["otherMethodDescription"] = this.otherMethodDescription !== undefined ? this.otherMethodDescription : <any>null;
        return data;
    }
}

export interface IDosageMethodResponse {
    method: string;
    otherMethodDescription?: string | null;
}

export class DosageSiteResponse implements IDosageSiteResponse {
    site!: string;
    otherSiteDescription?: string | null;

    constructor(data?: IDosageSiteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.otherSiteDescription = _data["otherSiteDescription"] !== undefined ? _data["otherSiteDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageSiteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["otherSiteDescription"] = this.otherSiteDescription !== undefined ? this.otherSiteDescription : <any>null;
        return data;
    }
}

export interface IDosageSiteResponse {
    site: string;
    otherSiteDescription?: string | null;
}

export class DosageSiteQualifierResponse implements IDosageSiteQualifierResponse {
    siteQualifier!: string;
    otherSiteQualifierDescription?: string | null;

    constructor(data?: IDosageSiteQualifierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteQualifier = _data["siteQualifier"] !== undefined ? _data["siteQualifier"] : <any>null;
            this.otherSiteQualifierDescription = _data["otherSiteQualifierDescription"] !== undefined ? _data["otherSiteQualifierDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageSiteQualifierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteQualifierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteQualifier"] = this.siteQualifier !== undefined ? this.siteQualifier : <any>null;
        data["otherSiteQualifierDescription"] = this.otherSiteQualifierDescription !== undefined ? this.otherSiteQualifierDescription : <any>null;
        return data;
    }
}

export interface IDosageSiteQualifierResponse {
    siteQualifier: string;
    otherSiteQualifierDescription?: string | null;
}

export class DosageTimingResponse implements IDosageTimingResponse {
    bounds?: DosageTimingBoundsResponse | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek!: DayOfWeek[];
    periodsOfDay!: string[];
    timesOfDay!: string[];

    constructor(data?: IDosageTimingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.daysOfWeek = [];
            this.periodsOfDay = [];
            this.timesOfDay = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bounds = _data["bounds"] ? DosageTimingBoundsResponse.fromJS(_data["bounds"]) : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.durationUnit = _data["durationUnit"] !== undefined ? _data["durationUnit"] : <any>null;
            this.subSequenceDuration = _data["subSequenceDuration"] !== undefined ? _data["subSequenceDuration"] : <any>null;
            this.subSequenceDurationUnit = _data["subSequenceDurationUnit"] !== undefined ? _data["subSequenceDurationUnit"] : <any>null;
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            else {
                this.daysOfWeek = <any>null;
            }
            if (Array.isArray(_data["periodsOfDay"])) {
                this.periodsOfDay = [] as any;
                for (let item of _data["periodsOfDay"])
                    this.periodsOfDay!.push(item);
            }
            else {
                this.periodsOfDay = <any>null;
            }
            if (Array.isArray(_data["timesOfDay"])) {
                this.timesOfDay = [] as any;
                for (let item of _data["timesOfDay"])
                    this.timesOfDay!.push(item);
            }
            else {
                this.timesOfDay = <any>null;
            }
        }
    }

    static fromJS(data: any): DosageTimingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageTimingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bounds"] = this.bounds ? this.bounds.toJSON() : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["durationUnit"] = this.durationUnit !== undefined ? this.durationUnit : <any>null;
        data["subSequenceDuration"] = this.subSequenceDuration !== undefined ? this.subSequenceDuration : <any>null;
        data["subSequenceDurationUnit"] = this.subSequenceDurationUnit !== undefined ? this.subSequenceDurationUnit : <any>null;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        if (Array.isArray(this.periodsOfDay)) {
            data["periodsOfDay"] = [];
            for (let item of this.periodsOfDay)
                data["periodsOfDay"].push(item);
        }
        if (Array.isArray(this.timesOfDay)) {
            data["timesOfDay"] = [];
            for (let item of this.timesOfDay)
                data["timesOfDay"].push(item);
        }
        return data;
    }
}

export interface IDosageTimingResponse {
    bounds?: DosageTimingBoundsResponse | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek: DayOfWeek[];
    periodsOfDay: string[];
    timesOfDay: string[];
}

export class DosageTimingBoundsResponse implements IDosageTimingBoundsResponse {

    protected _discriminator: string;

    constructor(data?: IDosageTimingBoundsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DosageTimingBoundsResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageTimingBoundsResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DosageTimingBoundsDurationResponse") {
            let result = new DosageTimingBoundsDurationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DosageTimingBoundsRangeResponse") {
            let result = new DosageTimingBoundsRangeResponse();
            result.init(data);
            return result;
        }
        let result = new DosageTimingBoundsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IDosageTimingBoundsResponse {
}

export class DosageTimingBoundsDurationResponse extends DosageTimingBoundsResponse implements IDosageTimingBoundsDurationResponse {
    value!: number;
    unit!: string;

    constructor(data?: IDosageTimingBoundsDurationResponse) {
        super(data);
        this._discriminator = "DosageTimingBoundsDurationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageTimingBoundsDurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageTimingBoundsDurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageTimingBoundsDurationResponse extends IDosageTimingBoundsResponse {
    value: number;
    unit: string;
}

export class DosageTimingBoundsRangeResponse extends DosageTimingBoundsResponse implements IDosageTimingBoundsRangeResponse {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IDosageTimingBoundsRangeResponse) {
        super(data);
        this._discriminator = "DosageTimingBoundsRangeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : <any>null;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageTimingBoundsRangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageTimingBoundsRangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : <any>null;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageTimingBoundsRangeResponse extends IDosageTimingBoundsResponse {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export enum DayOfWeek {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class DosageDoseAndRateResponse implements IDosageDoseAndRateResponse {
    rate?: DosageRateResponse | null;
    dose?: DosageDoseResponse | null;

    constructor(data?: IDosageDoseAndRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] ? DosageRateResponse.fromJS(_data["rate"]) : <any>null;
            this.dose = _data["dose"] ? DosageDoseResponse.fromJS(_data["dose"]) : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseAndRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseAndRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate ? this.rate.toJSON() : <any>null;
        data["dose"] = this.dose ? this.dose.toJSON() : <any>null;
        return data;
    }
}

export interface IDosageDoseAndRateResponse {
    rate?: DosageRateResponse | null;
    dose?: DosageDoseResponse | null;
}

export class DosageRateResponse implements IDosageRateResponse {
    value?: number | null;
    unit!: string;

    constructor(data?: IDosageRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface IDosageRateResponse {
    value?: number | null;
    unit: string;
}

export class DosageDoseResponse implements IDosageDoseResponse {

    protected _discriminator: string;

    constructor(data?: IDosageDoseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DosageDoseResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageDoseResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DosageDoseRangeResponse") {
            let result = new DosageDoseRangeResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DosageDoseQuantityResponse") {
            let result = new DosageDoseQuantityResponse();
            result.init(data);
            return result;
        }
        let result = new DosageDoseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IDosageDoseResponse {
}

export class DosageDoseRangeResponse extends DosageDoseResponse implements IDosageDoseRangeResponse {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IDosageDoseRangeResponse) {
        super(data);
        this._discriminator = "DosageDoseRangeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : <any>null;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseRangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseRangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : <any>null;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseRangeResponse extends IDosageDoseResponse {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export class DosageDoseQuantityResponse extends DosageDoseResponse implements IDosageDoseQuantityResponse {
    value?: number | null;
    unit?: string | null;

    constructor(data?: IDosageDoseQuantityResponse) {
        super(data);
        this._discriminator = "DosageDoseQuantityResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseQuantityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseQuantityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseQuantityResponse extends IDosageDoseResponse {
    value?: number | null;
    unit?: string | null;
}

export class DosageRouteResponse implements IDosageRouteResponse {
    route!: string;
    otherRouteDescription?: string | null;

    constructor(data?: IDosageRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"] !== undefined ? _data["route"] : <any>null;
            this.otherRouteDescription = _data["otherRouteDescription"] !== undefined ? _data["otherRouteDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route !== undefined ? this.route : <any>null;
        data["otherRouteDescription"] = this.otherRouteDescription !== undefined ? this.otherRouteDescription : <any>null;
        return data;
    }
}

export interface IDosageRouteResponse {
    route: string;
    otherRouteDescription?: string | null;
}

export class DosageMedicalDeviceResponse implements IDosageMedicalDeviceResponse {
    otherDescription?: string | null;
    displayText?: string | null;

    constructor(data?: IDosageMedicalDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherDescription = _data["otherDescription"] !== undefined ? _data["otherDescription"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMedicalDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMedicalDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherDescription"] = this.otherDescription !== undefined ? this.otherDescription : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IDosageMedicalDeviceResponse {
    otherDescription?: string | null;
    displayText?: string | null;
}

export class PersonResponse implements IPersonResponse {
    fullName?: string | null;

    protected _discriminator: string;

    constructor(data?: IPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PersonResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): PersonResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "PractitionerResponse") {
            let result = new PractitionerResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PatientResponse") {
            let result = new PatientResponse();
            result.init(data);
            return result;
        }
        let result = new PersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IPersonResponse {
    fullName?: string | null;
}

export class PractitionerResponse extends PersonResponse implements IPractitionerResponse {
    phones!: TelecomResponse[];
    role?: string | null;
    workplaceName?: string | null;
    addresses!: AddressResponse[];

    constructor(data?: IPractitionerResponse) {
        super(data);
        if (!data) {
            this.phones = [];
            this.addresses = [];
        }
        this._discriminator = "PractitionerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(TelecomResponse.fromJS(item));
            }
            else {
                this.phones = <any>null;
            }
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.workplaceName = _data["workplaceName"] !== undefined ? _data["workplaceName"] : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressResponse.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
        }
    }

    static fromJS(data: any): PractitionerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PractitionerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : <any>null);
        }
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["workplaceName"] = this.workplaceName !== undefined ? this.workplaceName : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPractitionerResponse extends IPersonResponse {
    phones: TelecomResponse[];
    role?: string | null;
    workplaceName?: string | null;
    addresses: AddressResponse[];
}

export class TelecomResponse implements ITelecomResponse {
    phoneNumber!: string;
    availableToPatient!: boolean;
    contactPointType?: string | null;

    constructor(data?: ITelecomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.availableToPatient = _data["availableToPatient"] !== undefined ? _data["availableToPatient"] : <any>null;
            this.contactPointType = _data["contactPointType"] !== undefined ? _data["contactPointType"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["availableToPatient"] = this.availableToPatient !== undefined ? this.availableToPatient : <any>null;
        data["contactPointType"] = this.contactPointType !== undefined ? this.contactPointType : <any>null;
        return data;
    }
}

export interface ITelecomResponse {
    phoneNumber: string;
    availableToPatient: boolean;
    contactPointType?: string | null;
}

export class AddressResponse implements IAddressResponse {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: IAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : <any>null;
            if (Array.isArray(_data["line"])) {
                this.line = [] as any;
                for (let item of _data["line"])
                    this.line!.push(item);
            }
            else {
                this.line = <any>null;
            }
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
        }
    }

    static fromJS(data: any): AddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType !== undefined ? this.addressType : <any>null;
        if (Array.isArray(this.line)) {
            data["line"] = [];
            for (let item of this.line)
                data["line"].push(item);
        }
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        return data;
    }
}

export interface IAddressResponse {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export enum AddressType {
    Physical = "Physical",
    Postal = "Postal",
    Both = "Both",
}

export class PatientResponse extends PersonResponse implements IPatientResponse {

    constructor(data?: IPatientResponse) {
        super(data);
        this._discriminator = "PatientResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PatientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPatientResponse extends IPersonResponse {
}

export class DispenseInformationResponse implements IDispenseInformationResponse {
    hasTrialDispense!: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct!: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalResponse | null;
    substitutionOpposed?: string | null;
    dosePackaging!: boolean;

    constructor(data?: IDispenseInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTrialDispense = _data["hasTrialDispense"] !== undefined ? _data["hasTrialDispense"] : <any>null;
            this.patientIsEligibleForPharmaceuticalBenefitsAct = _data["patientIsEligibleForPharmaceuticalBenefitsAct"] !== undefined ? _data["patientIsEligibleForPharmaceuticalBenefitsAct"] : <any>null;
            this.prescriptionIsAccordingToCommunicableDiseasesAct = _data["prescriptionIsAccordingToCommunicableDiseasesAct"] !== undefined ? _data["prescriptionIsAccordingToCommunicableDiseasesAct"] : <any>null;
            this.patientFulfillsConditionsPharmaceuticalBenefitsAct = _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] !== undefined ? _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] : <any>null;
            this.lastDateOfValidity = _data["lastDateOfValidity"] ? moment(_data["lastDateOfValidity"].toString()) : <any>null;
            this.firstDispenseBefore = _data["firstDispenseBefore"] ? moment(_data["firstDispenseBefore"].toString()) : <any>null;
            this.numberOfPackagesPrescribed = _data["numberOfPackagesPrescribed"] !== undefined ? _data["numberOfPackagesPrescribed"] : <any>null;
            this.remainingQuantity = _data["remainingQuantity"] !== undefined ? _data["remainingQuantity"] : <any>null;
            this.numberOfFillsRemaining = _data["numberOfFillsRemaining"] !== undefined ? _data["numberOfFillsRemaining"] : <any>null;
            this.numberOfDispensesAllowed = _data["numberOfDispensesAllowed"] !== undefined ? _data["numberOfDispensesAllowed"] : <any>null;
            this.dispenseInterval = _data["dispenseInterval"] ? DispenseIntervalResponse.fromJS(_data["dispenseInterval"]) : <any>null;
            this.substitutionOpposed = _data["substitutionOpposed"] !== undefined ? _data["substitutionOpposed"] : <any>null;
            this.dosePackaging = _data["dosePackaging"] !== undefined ? _data["dosePackaging"] : <any>null;
        }
    }

    static fromJS(data: any): DispenseInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTrialDispense"] = this.hasTrialDispense !== undefined ? this.hasTrialDispense : <any>null;
        data["patientIsEligibleForPharmaceuticalBenefitsAct"] = this.patientIsEligibleForPharmaceuticalBenefitsAct !== undefined ? this.patientIsEligibleForPharmaceuticalBenefitsAct : <any>null;
        data["prescriptionIsAccordingToCommunicableDiseasesAct"] = this.prescriptionIsAccordingToCommunicableDiseasesAct !== undefined ? this.prescriptionIsAccordingToCommunicableDiseasesAct : <any>null;
        data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] = this.patientFulfillsConditionsPharmaceuticalBenefitsAct !== undefined ? this.patientFulfillsConditionsPharmaceuticalBenefitsAct : <any>null;
        data["lastDateOfValidity"] = this.lastDateOfValidity ? this.lastDateOfValidity.format('YYYY-MM-DD') : <any>null;
        data["firstDispenseBefore"] = this.firstDispenseBefore ? this.firstDispenseBefore.format('YYYY-MM-DD') : <any>null;
        data["numberOfPackagesPrescribed"] = this.numberOfPackagesPrescribed !== undefined ? this.numberOfPackagesPrescribed : <any>null;
        data["remainingQuantity"] = this.remainingQuantity !== undefined ? this.remainingQuantity : <any>null;
        data["numberOfFillsRemaining"] = this.numberOfFillsRemaining !== undefined ? this.numberOfFillsRemaining : <any>null;
        data["numberOfDispensesAllowed"] = this.numberOfDispensesAllowed !== undefined ? this.numberOfDispensesAllowed : <any>null;
        data["dispenseInterval"] = this.dispenseInterval ? this.dispenseInterval.toJSON() : <any>null;
        data["substitutionOpposed"] = this.substitutionOpposed !== undefined ? this.substitutionOpposed : <any>null;
        data["dosePackaging"] = this.dosePackaging !== undefined ? this.dosePackaging : <any>null;
        return data;
    }
}

export interface IDispenseInformationResponse {
    hasTrialDispense: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalResponse | null;
    substitutionOpposed?: string | null;
    dosePackaging: boolean;
}

export class DispenseIntervalResponse implements IDispenseIntervalResponse {
    value!: number;
    unit!: string;

    constructor(data?: IDispenseIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DispenseIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface IDispenseIntervalResponse {
    value: number;
    unit: string;
}

export class WarningResponse implements IWarningResponse {
    message!: string;

    constructor(data?: IWarningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): WarningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WarningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface IWarningResponse {
    message: string;
}

export class MedicationDispenseResponse implements IMedicationDispenseResponse {
    id!: string;
    version!: number;
    authorizingPrescription!: AuthorizingPrescriptionResponse;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted!: boolean;
    dispenseType!: string;
    benefitChoice!: string;
    noteMarkdown?: string | null;
    status!: MedicationDispenseStatusType;
    dosageInstructions!: DosageInstructionResponse[];
    medication!: MedicationResponse;

    constructor(data?: IMedicationDispenseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.authorizingPrescription = new AuthorizingPrescriptionResponse();
            this.dosageInstructions = [];
            this.medication = new MedicationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.authorizingPrescription = _data["authorizingPrescription"] ? AuthorizingPrescriptionResponse.fromJS(_data["authorizingPrescription"]) : new AuthorizingPrescriptionResponse();
            this.expeditionTime = _data["expeditionTime"] ? moment(_data["expeditionTime"].toString()) : <any>null;
            this.creditTime = _data["creditTime"] ? moment(_data["creditTime"].toString()) : <any>null;
            this.numberOfPackagesDispensed = _data["numberOfPackagesDispensed"] !== undefined ? _data["numberOfPackagesDispensed"] : <any>null;
            this.expeditionQuantity = _data["expeditionQuantity"] !== undefined ? _data["expeditionQuantity"] : <any>null;
            this.wasSubstituted = _data["wasSubstituted"] !== undefined ? _data["wasSubstituted"] : <any>null;
            this.dispenseType = _data["dispenseType"] !== undefined ? _data["dispenseType"] : <any>null;
            this.benefitChoice = _data["benefitChoice"] !== undefined ? _data["benefitChoice"] : <any>null;
            this.noteMarkdown = _data["noteMarkdown"] !== undefined ? _data["noteMarkdown"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionResponse.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.medication = _data["medication"] ? MedicationResponse.fromJS(_data["medication"]) : new MedicationResponse();
        }
    }

    static fromJS(data: any): MedicationDispenseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDispenseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["authorizingPrescription"] = this.authorizingPrescription ? this.authorizingPrescription.toJSON() : <any>null;
        data["expeditionTime"] = this.expeditionTime ? this.expeditionTime.toISOString() : <any>null;
        data["creditTime"] = this.creditTime ? this.creditTime.toISOString() : <any>null;
        data["numberOfPackagesDispensed"] = this.numberOfPackagesDispensed !== undefined ? this.numberOfPackagesDispensed : <any>null;
        data["expeditionQuantity"] = this.expeditionQuantity !== undefined ? this.expeditionQuantity : <any>null;
        data["wasSubstituted"] = this.wasSubstituted !== undefined ? this.wasSubstituted : <any>null;
        data["dispenseType"] = this.dispenseType !== undefined ? this.dispenseType : <any>null;
        data["benefitChoice"] = this.benefitChoice !== undefined ? this.benefitChoice : <any>null;
        data["noteMarkdown"] = this.noteMarkdown !== undefined ? this.noteMarkdown : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        return data;
    }
}

export interface IMedicationDispenseResponse {
    id: string;
    version: number;
    authorizingPrescription: AuthorizingPrescriptionResponse;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted: boolean;
    dispenseType: string;
    benefitChoice: string;
    noteMarkdown?: string | null;
    status: MedicationDispenseStatusType;
    dosageInstructions: DosageInstructionResponse[];
    medication: MedicationResponse;
}

export class AuthorizingPrescriptionResponse implements IAuthorizingPrescriptionResponse {
    id!: string;
    version!: number;

    constructor(data?: IAuthorizingPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): AuthorizingPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizingPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IAuthorizingPrescriptionResponse {
    id: string;
    version: number;
}

export enum MedicationDispenseStatusType {
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class NoteResponse implements INoteResponse {
    noteType!: NoteType;
    noteTypeDisplayText!: string;
    textMarkdown!: string;

    constructor(data?: INoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.noteTypeDisplayText = _data["noteTypeDisplayText"] !== undefined ? _data["noteTypeDisplayText"] : <any>null;
            this.textMarkdown = _data["textMarkdown"] !== undefined ? _data["textMarkdown"] : <any>null;
        }
    }

    static fromJS(data: any): NoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["noteTypeDisplayText"] = this.noteTypeDisplayText !== undefined ? this.noteTypeDisplayText : <any>null;
        data["textMarkdown"] = this.textMarkdown !== undefined ? this.textMarkdown : <any>null;
        return data;
    }
}

export interface INoteResponse {
    noteType: NoteType;
    noteTypeDisplayText: string;
    textMarkdown: string;
}

export enum NoteType {
    PrescriberToCare = "PrescriberToCare",
    PrescriberToPharmacy = "PrescriberToPharmacy",
    Pharmacy = "Pharmacy",
    Delivery = "Delivery",
}

export class PrescriptionReasonResponse implements IPrescriptionReasonResponse {
    isAbsent!: boolean;
    description?: string | null;
    displayText!: string;

    constructor(data?: IPrescriptionReasonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAbsent = _data["isAbsent"] !== undefined ? _data["isAbsent"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionReasonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionReasonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAbsent"] = this.isAbsent !== undefined ? this.isAbsent : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IPrescriptionReasonResponse {
    isAbsent: boolean;
    description?: string | null;
    displayText: string;
}

export class PaperPrescriptionResponse implements IPaperPrescriptionResponse {
    paperDispenseInformation!: PaperDispenseInformationResponse;
    medication!: MedicationResponse;
    practitioner!: PractitionerResponse;

    constructor(data?: IPaperPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paperDispenseInformation = new PaperDispenseInformationResponse();
            this.medication = new MedicationResponse();
            this.practitioner = new PractitionerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperDispenseInformation = _data["paperDispenseInformation"] ? PaperDispenseInformationResponse.fromJS(_data["paperDispenseInformation"]) : new PaperDispenseInformationResponse();
            this.medication = _data["medication"] ? MedicationResponse.fromJS(_data["medication"]) : new MedicationResponse();
            this.practitioner = _data["practitioner"] ? PractitionerResponse.fromJS(_data["practitioner"]) : new PractitionerResponse();
        }
    }

    static fromJS(data: any): PaperPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaperPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperDispenseInformation"] = this.paperDispenseInformation ? this.paperDispenseInformation.toJSON() : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        return data;
    }
}

export interface IPaperPrescriptionResponse {
    paperDispenseInformation: PaperDispenseInformationResponse;
    medication: MedicationResponse;
    practitioner: PractitionerResponse;
}

export class PaperDispenseInformationResponse implements IPaperDispenseInformationResponse {
    id!: string;
    expeditionTime!: moment.Moment;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    patientInstruction?: string | null;

    constructor(data?: IPaperDispenseInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.expeditionTime = _data["expeditionTime"] ? moment(_data["expeditionTime"].toString()) : <any>null;
            this.creditTime = _data["creditTime"] ? moment(_data["creditTime"].toString()) : <any>null;
            this.numberOfPackagesDispensed = _data["numberOfPackagesDispensed"] !== undefined ? _data["numberOfPackagesDispensed"] : <any>null;
            this.expeditionQuantity = _data["expeditionQuantity"] !== undefined ? _data["expeditionQuantity"] : <any>null;
            this.patientInstruction = _data["patientInstruction"] !== undefined ? _data["patientInstruction"] : <any>null;
        }
    }

    static fromJS(data: any): PaperDispenseInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaperDispenseInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["expeditionTime"] = this.expeditionTime ? this.expeditionTime.toISOString() : <any>null;
        data["creditTime"] = this.creditTime ? this.creditTime.toISOString() : <any>null;
        data["numberOfPackagesDispensed"] = this.numberOfPackagesDispensed !== undefined ? this.numberOfPackagesDispensed : <any>null;
        data["expeditionQuantity"] = this.expeditionQuantity !== undefined ? this.expeditionQuantity : <any>null;
        data["patientInstruction"] = this.patientInstruction !== undefined ? this.patientInstruction : <any>null;
        return data;
    }
}

export interface IPaperDispenseInformationResponse {
    id: string;
    expeditionTime: moment.Moment;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    patientInstruction?: string | null;
}

export class PrescriptionVersionResponse implements IPrescriptionVersionResponse {
    id!: string;
    version!: number;
    prescriptionFormat!: string;
    authoredOn!: moment.Moment;
    medication!: MedicationResponse;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoResponse | null;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionResponse[];
    treatmentReason?: string | null;
    practitioner!: PractitionerResponse;
    dispenseInformation!: DispenseInformationResponse;
    notes!: NoteResponse[];
    prescriptionReasons!: PrescriptionReasonResponse[];

    constructor(data?: IPrescriptionVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationResponse();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerResponse();
            this.dispenseInformation = new DispenseInformationResponse();
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.medication = _data["medication"] ? MedicationResponse.fromJS(_data["medication"]) : new MedicationResponse();
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : <any>null;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoResponse.fromJS(_data["priorityInfo"]) : <any>null;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : <any>null;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionResponse.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : <any>null;
            this.practitioner = _data["practitioner"] ? PractitionerResponse.fromJS(_data["practitioner"]) : new PractitionerResponse();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationResponse.fromJS(_data["dispenseInformation"]) : new DispenseInformationResponse();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteResponse.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonResponse.fromJS(item));
            }
            else {
                this.prescriptionReasons = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : <any>null;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : <any>null;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : <any>null;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : <any>null;
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : <any>null;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionVersionResponse {
    id: string;
    version: number;
    prescriptionFormat: string;
    authoredOn: moment.Moment;
    medication: MedicationResponse;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoResponse | null;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionResponse[];
    treatmentReason?: string | null;
    practitioner: PractitionerResponse;
    dispenseInformation: DispenseInformationResponse;
    notes: NoteResponse[];
    prescriptionReasons: PrescriptionReasonResponse[];
}

export enum PrescriptionType {
    Pharmaceutical = "Pharmaceutical",
    MedicalConsumable = "MedicalConsumable",
}

export class PrescriptionEventsResponse implements IPrescriptionEventsResponse {
    prescriptionId!: string;
    medicationListVersion!: number;
    events!: PrescriptionEventResponse[];

    constructor(data?: IPrescriptionEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.medicationListVersion = _data["medicationListVersion"] !== undefined ? _data["medicationListVersion"] : <any>null;
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(PrescriptionEventResponse.fromJS(item));
            }
            else {
                this.events = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["medicationListVersion"] = this.medicationListVersion !== undefined ? this.medicationListVersion : <any>null;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionEventsResponse {
    prescriptionId: string;
    medicationListVersion: number;
    events: PrescriptionEventResponse[];
}

export class PrescriptionEventResponse implements IPrescriptionEventResponse {
    recordedOn!: moment.Moment;
    action!: string;
    reason?: string | null;
    reasonDescription?: string | null;
    prescriptionVersion!: number;
    participants!: EventParticipantResponse[];

    constructor(data?: IPrescriptionEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.participants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordedOn = _data["recordedOn"] ? moment(_data["recordedOn"].toString()) : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.reasonDescription = _data["reasonDescription"] !== undefined ? _data["reasonDescription"] : <any>null;
            this.prescriptionVersion = _data["prescriptionVersion"] !== undefined ? _data["prescriptionVersion"] : <any>null;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(EventParticipantResponse.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordedOn"] = this.recordedOn ? this.recordedOn.toISOString() : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["reasonDescription"] = this.reasonDescription !== undefined ? this.reasonDescription : <any>null;
        data["prescriptionVersion"] = this.prescriptionVersion !== undefined ? this.prescriptionVersion : <any>null;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionEventResponse {
    recordedOn: moment.Moment;
    action: string;
    reason?: string | null;
    reasonDescription?: string | null;
    prescriptionVersion: number;
    participants: EventParticipantResponse[];
}

export class EventParticipantResponse implements IEventParticipantResponse {
    participantType!: string;
    person!: PersonResponse;

    constructor(data?: IEventParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.person = new PersonResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantType = _data["participantType"] !== undefined ? _data["participantType"] : <any>null;
            this.person = _data["person"] ? PersonResponse.fromJS(_data["person"]) : new PersonResponse();
        }
    }

    static fromJS(data: any): EventParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EventParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantType"] = this.participantType !== undefined ? this.participantType : <any>null;
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        return data;
    }
}

export interface IEventParticipantResponse {
    participantType: string;
    person: PersonResponse;
}

export class PatientSessionInitiatedResponse implements IPatientSessionInitiatedResponse {
    sessionId!: string;
    ssn?: string | null;
    fullName?: string | null;
    isDeceased!: boolean;
    hasConfidentialityFlag!: boolean;
    hasProtectedAddress!: boolean;
    dateOfBirth?: string | null;

    constructor(data?: IPatientSessionInitiatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"] !== undefined ? _data["sessionId"] : <any>null;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.isDeceased = _data["isDeceased"] !== undefined ? _data["isDeceased"] : <any>null;
            this.hasConfidentialityFlag = _data["hasConfidentialityFlag"] !== undefined ? _data["hasConfidentialityFlag"] : <any>null;
            this.hasProtectedAddress = _data["hasProtectedAddress"] !== undefined ? _data["hasProtectedAddress"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : <any>null;
        }
    }

    static fromJS(data: any): PatientSessionInitiatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSessionInitiatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId !== undefined ? this.sessionId : <any>null;
        data["ssn"] = this.ssn !== undefined ? this.ssn : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["isDeceased"] = this.isDeceased !== undefined ? this.isDeceased : <any>null;
        data["hasConfidentialityFlag"] = this.hasConfidentialityFlag !== undefined ? this.hasConfidentialityFlag : <any>null;
        data["hasProtectedAddress"] = this.hasProtectedAddress !== undefined ? this.hasProtectedAddress : <any>null;
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : <any>null;
        return data;
    }
}

export interface IPatientSessionInitiatedResponse {
    sessionId: string;
    ssn?: string | null;
    fullName?: string | null;
    isDeceased: boolean;
    hasConfidentialityFlag: boolean;
    hasProtectedAddress: boolean;
    dateOfBirth?: string | null;
}

export class ValueSetDisplay implements IValueSetDisplay {
    displayValue!: string;

    constructor(data?: IValueSetDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayValue = _data["displayValue"] !== undefined ? _data["displayValue"] : <any>null;
        }
    }

    static fromJS(data: any): ValueSetDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new ValueSetDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayValue"] = this.displayValue !== undefined ? this.displayValue : <any>null;
        return data;
    }
}

export interface IValueSetDisplay {
    displayValue: string;
}

export class MedicationListInfoResponse implements IMedicationListInfoResponse {
    hasPrivacyLockedContent?: boolean | null;
    medicationListVersion!: number;
    hasControlledDrugs?: boolean | null;

    constructor(data?: IMedicationListInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPrivacyLockedContent = _data["hasPrivacyLockedContent"] !== undefined ? _data["hasPrivacyLockedContent"] : <any>null;
            this.medicationListVersion = _data["medicationListVersion"] !== undefined ? _data["medicationListVersion"] : <any>null;
            this.hasControlledDrugs = _data["hasControlledDrugs"] !== undefined ? _data["hasControlledDrugs"] : <any>null;
        }
    }

    static fromJS(data: any): MedicationListInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationListInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPrivacyLockedContent"] = this.hasPrivacyLockedContent !== undefined ? this.hasPrivacyLockedContent : <any>null;
        data["medicationListVersion"] = this.medicationListVersion !== undefined ? this.medicationListVersion : <any>null;
        data["hasControlledDrugs"] = this.hasControlledDrugs !== undefined ? this.hasControlledDrugs : <any>null;
        return data;
    }
}

export interface IMedicationListInfoResponse {
    hasPrivacyLockedContent?: boolean | null;
    medicationListVersion: number;
    hasControlledDrugs?: boolean | null;
}

export class HealthcareProviderInformationResponse implements IHealthcareProviderInformationResponse {
    customerId!: string;
    name?: string | null;
    healthcareUnits!: HealthcareUnitResponse[];

    constructor(data?: IHealthcareProviderInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.healthcareUnits = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["healthcareUnits"])) {
                this.healthcareUnits = [] as any;
                for (let item of _data["healthcareUnits"])
                    this.healthcareUnits!.push(HealthcareUnitResponse.fromJS(item));
            }
            else {
                this.healthcareUnits = <any>null;
            }
        }
    }

    static fromJS(data: any): HealthcareProviderInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareProviderInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.healthcareUnits)) {
            data["healthcareUnits"] = [];
            for (let item of this.healthcareUnits)
                data["healthcareUnits"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IHealthcareProviderInformationResponse {
    customerId: string;
    name?: string | null;
    healthcareUnits: HealthcareUnitResponse[];
}

export class HealthcareUnitResponse implements IHealthcareUnitResponse {
    location!: string;
    hsaId!: string;
    name!: string;
    organisationId!: string;

    constructor(data?: IHealthcareUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.hsaId = _data["hsaId"] !== undefined ? _data["hsaId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
        }
    }

    static fromJS(data: any): HealthcareUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["hsaId"] = this.hsaId !== undefined ? this.hsaId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        return data;
    }
}

export interface IHealthcareUnitResponse {
    location: string;
    hsaId: string;
    name: string;
    organisationId: string;
}

export class HealthcareProviderInformationRequest implements IHealthcareProviderInformationRequest {
    customerId!: string;
    name?: string | null;
    healthcareUnits!: HealthcareUnitRequest[];

    constructor(data?: IHealthcareProviderInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.healthcareUnits = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["healthcareUnits"])) {
                this.healthcareUnits = [] as any;
                for (let item of _data["healthcareUnits"])
                    this.healthcareUnits!.push(HealthcareUnitRequest.fromJS(item));
            }
            else {
                this.healthcareUnits = <any>null;
            }
        }
    }

    static fromJS(data: any): HealthcareProviderInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareProviderInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.healthcareUnits)) {
            data["healthcareUnits"] = [];
            for (let item of this.healthcareUnits)
                data["healthcareUnits"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IHealthcareProviderInformationRequest {
    customerId: string;
    name?: string | null;
    healthcareUnits: HealthcareUnitRequest[];
}

export class HealthcareUnitRequest implements IHealthcareUnitRequest {
    location!: string;
    hsaId!: string;
    name!: string;
    organisationId!: string;

    constructor(data?: IHealthcareUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.hsaId = _data["hsaId"] !== undefined ? _data["hsaId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
        }
    }

    static fromJS(data: any): HealthcareUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["hsaId"] = this.hsaId !== undefined ? this.hsaId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        return data;
    }
}

export interface IHealthcareUnitRequest {
    location: string;
    hsaId: string;
    name: string;
    organisationId: string;
}

export class DataLockDetailsResponse implements IDataLockDetailsResponse {
    dataLockEvent!: DataLockEventResponse;

    constructor(data?: IDataLockDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataLockEvent = new DataLockEventResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataLockEvent = _data["dataLockEvent"] ? DataLockEventResponse.fromJS(_data["dataLockEvent"]) : new DataLockEventResponse();
        }
    }

    static fromJS(data: any): DataLockDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataLockDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataLockEvent"] = this.dataLockEvent ? this.dataLockEvent.toJSON() : <any>null;
        return data;
    }
}

export interface IDataLockDetailsResponse {
    dataLockEvent: DataLockEventResponse;
}

export class DataLockEventResponse implements IDataLockEventResponse {
    recordedOn!: moment.Moment;
    action!: string;
    participants!: EventParticipantResponse[];

    constructor(data?: IDataLockEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.participants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordedOn = _data["recordedOn"] ? moment(_data["recordedOn"].toString()) : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(EventParticipantResponse.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
        }
    }

    static fromJS(data: any): DataLockEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataLockEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordedOn"] = this.recordedOn ? this.recordedOn.toISOString() : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IDataLockEventResponse {
    recordedOn: moment.Moment;
    action: string;
    participants: EventParticipantResponse[];
}

export class PreObtainedConsentsResponse implements IPreObtainedConsentsResponse {
    doseConsent?: DoseConsentResponse | null;
    registeredConsent?: RegisteredConsentResponse | null;

    constructor(data?: IPreObtainedConsentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseConsent = _data["doseConsent"] ? DoseConsentResponse.fromJS(_data["doseConsent"]) : <any>null;
            this.registeredConsent = _data["registeredConsent"] ? RegisteredConsentResponse.fromJS(_data["registeredConsent"]) : <any>null;
        }
    }

    static fromJS(data: any): PreObtainedConsentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreObtainedConsentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseConsent"] = this.doseConsent ? this.doseConsent.toJSON() : <any>null;
        data["registeredConsent"] = this.registeredConsent ? this.registeredConsent.toJSON() : <any>null;
        return data;
    }
}

export interface IPreObtainedConsentsResponse {
    doseConsent?: DoseConsentResponse | null;
    registeredConsent?: RegisteredConsentResponse | null;
}

export class DoseConsentResponse implements IDoseConsentResponse {
    status!: ConsentStatus;
    provisionPeriodStart?: moment.Moment | null;
    doseBasis!: DoseBasisResponse;

    constructor(data?: IDoseConsentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doseBasis = new DoseBasisResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.provisionPeriodStart = _data["provisionPeriodStart"] ? moment(_data["provisionPeriodStart"].toString()) : <any>null;
            this.doseBasis = _data["doseBasis"] ? DoseBasisResponse.fromJS(_data["doseBasis"]) : new DoseBasisResponse();
        }
    }

    static fromJS(data: any): DoseConsentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DoseConsentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["provisionPeriodStart"] = this.provisionPeriodStart ? this.provisionPeriodStart.toISOString() : <any>null;
        data["doseBasis"] = this.doseBasis ? this.doseBasis.toJSON() : <any>null;
        return data;
    }
}

export interface IDoseConsentResponse {
    status: ConsentStatus;
    provisionPeriodStart?: moment.Moment | null;
    doseBasis: DoseBasisResponse;
}

export enum ConsentStatus {
    Proposed = "proposed",
    Active = "active",
    Inactive = "inactive",
}

export class DoseBasisResponse implements IDoseBasisResponse {
    producingPharmacy?: string | null;

    constructor(data?: IDoseBasisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.producingPharmacy = _data["producingPharmacy"] !== undefined ? _data["producingPharmacy"] : <any>null;
        }
    }

    static fromJS(data: any): DoseBasisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DoseBasisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["producingPharmacy"] = this.producingPharmacy !== undefined ? this.producingPharmacy : <any>null;
        return data;
    }
}

export interface IDoseBasisResponse {
    producingPharmacy?: string | null;
}

export class RegisteredConsentResponse implements IRegisteredConsentResponse {
    status!: ConsentStatus;
    provisionPeriodStart?: moment.Moment | null;
    provisionPeriodEnd?: moment.Moment | null;
    statusDisplayText!: string;
    recipientRole?: string | null;
    recipientName?: string | null;

    constructor(data?: IRegisteredConsentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.provisionPeriodStart = _data["provisionPeriodStart"] ? moment(_data["provisionPeriodStart"].toString()) : <any>null;
            this.provisionPeriodEnd = _data["provisionPeriodEnd"] ? moment(_data["provisionPeriodEnd"].toString()) : <any>null;
            this.statusDisplayText = _data["statusDisplayText"] !== undefined ? _data["statusDisplayText"] : <any>null;
            this.recipientRole = _data["recipientRole"] !== undefined ? _data["recipientRole"] : <any>null;
            this.recipientName = _data["recipientName"] !== undefined ? _data["recipientName"] : <any>null;
        }
    }

    static fromJS(data: any): RegisteredConsentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredConsentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["provisionPeriodStart"] = this.provisionPeriodStart ? this.provisionPeriodStart.toISOString() : <any>null;
        data["provisionPeriodEnd"] = this.provisionPeriodEnd ? this.provisionPeriodEnd.toISOString() : <any>null;
        data["statusDisplayText"] = this.statusDisplayText !== undefined ? this.statusDisplayText : <any>null;
        data["recipientRole"] = this.recipientRole !== undefined ? this.recipientRole : <any>null;
        data["recipientName"] = this.recipientName !== undefined ? this.recipientName : <any>null;
        return data;
    }
}

export interface IRegisteredConsentResponse {
    status: ConsentStatus;
    provisionPeriodStart?: moment.Moment | null;
    provisionPeriodEnd?: moment.Moment | null;
    statusDisplayText: string;
    recipientRole?: string | null;
    recipientName?: string | null;
}

export class EstablishPreObtainedConsentsRequest implements IEstablishPreObtainedConsentsRequest {
    patientSessionId!: string;

    constructor(data?: IEstablishPreObtainedConsentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientSessionId = _data["patientSessionId"] !== undefined ? _data["patientSessionId"] : <any>null;
        }
    }

    static fromJS(data: any): EstablishPreObtainedConsentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstablishPreObtainedConsentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientSessionId"] = this.patientSessionId !== undefined ? this.patientSessionId : <any>null;
        return data;
    }
}

export interface IEstablishPreObtainedConsentsRequest {
    patientSessionId: string;
}

export class SelectConsentRequest implements ISelectConsentRequest {
    consentType!: ConsentType;
    patientSessionId!: string;

    constructor(data?: ISelectConsentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentType = _data["consentType"] !== undefined ? _data["consentType"] : <any>null;
            this.patientSessionId = _data["patientSessionId"] !== undefined ? _data["patientSessionId"] : <any>null;
        }
    }

    static fromJS(data: any): SelectConsentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelectConsentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentType"] = this.consentType !== undefined ? this.consentType : <any>null;
        data["patientSessionId"] = this.patientSessionId !== undefined ? this.patientSessionId : <any>null;
        return data;
    }
}

export interface ISelectConsentRequest {
    consentType: ConsentType;
    patientSessionId: string;
}

export enum ConsentType {
    Dose = "Dose",
    Registered = "Registered",
    Emergency = "Emergency",
    Temporary = "Temporary",
    Presumed = "Presumed",
    Without = "Without",
}

export class ElevateConsentRequest implements IElevateConsentRequest {
    patientSessionId!: string;
    reason!: string;

    constructor(data?: IElevateConsentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientSessionId = _data["patientSessionId"] !== undefined ? _data["patientSessionId"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): ElevateConsentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ElevateConsentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientSessionId"] = this.patientSessionId !== undefined ? this.patientSessionId : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IElevateConsentRequest {
    patientSessionId: string;
    reason: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}